import dynamic from "next/dynamic";

// 🚀 Eager — LCP-critical section
export { SpecialismPageBannerSection } from "./SpecialismPageBannerSection";

// 💤 Lazy — Heavy + below-the-fold sections
export const SpecialismPageContentSection = dynamic(() =>
  import("./SpecialismPageContentSection").then((m) => m.SpecialismPageContentSection)
);

export const SpecialismPageGridSection = dynamic(() =>
  import("./SpecialismPageGridSection").then((m) => m.SpecialismPageGridSection)
);

